import React from 'react';

export default function TerminosContent() {
  return (
    <>
      <p className="legal-lead">
        Los presentes Términos y Condiciones (en adelante, los &quot;Términos&quot;)
        regulan el acceso y uso del sitio web{' '}
        <strong>santamonicaresidencial.mx</strong> (en adelante, el &quot;Sitio&quot;),
        propiedad de <strong>Quru, S.A. de C.V.</strong> (en adelante,
        &quot;Quru&quot; o el &quot;Titular&quot;), así como la relación entre Quru
        y cualquier persona que ingrese, navegue o interactúe con el Sitio (en
        adelante, el &quot;Usuario&quot;).
      </p>
      <p>
        Al acceder y utilizar el Sitio, el Usuario manifiesta haber leído,
        comprendido y aceptado en su totalidad los presentes Términos. En caso de
        no estar de acuerdo, deberá abstenerse de utilizar el Sitio.
      </p>

      <h2>1. Objeto y alcance del Sitio</h2>
      <p>
        El Sitio tiene como objeto presentar de manera informativa y promocional el
        desarrollo inmobiliario <strong>Santa Mónica Residencial</strong>, ubicado en
        Pachuca de Soto, Hidalgo, así como facilitar el contacto entre prospectos
        interesados y el equipo comercial de Quru. La información publicada en el
        Sitio es de carácter ilustrativo y no constituye una oferta vinculante de
        compraventa.
      </p>

      <h2>2. Información comercial y disponibilidad</h2>
      <p>
        Las características, precios, planos, distribuciones, modelos, imágenes
        digitales, recorridos virtuales, renders, especificaciones técnicas y
        disponibilidad de lotes que se muestran en el Sitio son <strong>de carácter
        meramente referencial</strong> y pueden estar sujetos a cambios sin previo
        aviso por parte de Quru. Los precios se expresan en pesos mexicanos (MXN) y
        no incluyen los gastos de escrituración, avalúo, comisión por apertura,
        Certificado de Libertad de Gravamen (CLG), Impuesto Sobre Adquisición de
        Inmuebles (ISAI) ni otros gastos derivados del proceso de compra.
      </p>
      <p>
        Las condiciones definitivas de cada operación inmobiliaria se establecerán
        únicamente en los documentos contractuales firmados entre las partes
        (contrato de promesa de compraventa, contrato de compraventa y escritura
        pública).
      </p>

      <h2>3. Propiedad intelectual</h2>
      <p>
        La totalidad del contenido del Sitio, incluyendo de manera enunciativa y no
        limitativa: textos, fotografías, renders, videos, recorridos virtuales,
        planos, logotipos, marca &quot;Santa Mónica Residencial&quot;, marca
        &quot;Quru&quot;, diseños, código fuente, bases de datos, gráficos,
        composiciones musicales y cualesquiera otros elementos, son propiedad
        exclusiva de Quru o se utilizan con autorización expresa de sus titulares,
        y se encuentran protegidos por la Ley Federal del Derecho de Autor, la Ley
        Federal de Protección a la Propiedad Industrial y los tratados
        internacionales aplicables.
      </p>
      <p>
        Queda estrictamente prohibida cualquier reproducción, distribución,
        comunicación pública, transformación o utilización del contenido del Sitio
        sin la autorización previa, expresa y por escrito de Quru.
      </p>

      <h2>4. Uso permitido del Sitio</h2>
      <p>El Usuario se obliga a utilizar el Sitio únicamente con fines lícitos. Queda prohibido:</p>
      <ul>
        <li>Realizar cualquier acto que vulnere la seguridad, integridad o disponibilidad del Sitio (intentos de intrusión, escaneo, inyección de código, ataques de denegación de servicio, ingeniería inversa, etc.).</li>
        <li>Utilizar bots, scrapers, crawlers, spiders o cualquier herramienta automatizada para extraer información del Sitio sin autorización expresa.</li>
        <li>Suplantar la identidad de terceros o proporcionar información falsa, inexacta o desactualizada.</li>
        <li>Reproducir, copiar, distribuir o explotar comercialmente el contenido del Sitio.</li>
        <li>Utilizar el Sitio o sus formularios para fines ajenos a la consulta legítima sobre el desarrollo Santa Mónica Residencial.</li>
      </ul>

      <h2>5. Recorridos virtuales y contenido multimedia</h2>
      <p>
        Los recorridos virtuales 3D (tecnología Matterport) y las imágenes
        renderizadas presentadas en el Sitio son <strong>representaciones digitales
        de carácter ilustrativo</strong>. Pueden existir variaciones entre el
        contenido digital y la vivienda real entregada, derivadas de procesos
        constructivos, disponibilidad de materiales, especificaciones técnicas y
        adecuaciones solicitadas por el comprador. La conformidad final del
        producto será la que conste en el contrato de compraventa.
      </p>

      <h2>6. Asistente conversacional con inteligencia artificial</h2>
      <p>
        El Sitio puede ofrecer un asistente conversacional automatizado (&quot;Mónica&quot;)
        impulsado por inteligencia artificial. Las respuestas proporcionadas por
        Mónica tienen carácter <strong>informativo y orientativo</strong>, y no
        constituyen una promesa, oferta comercial o asesoría profesional. Los
        precios, disponibilidad, condiciones de crédito y cualquier información
        técnica deben ser confirmados directamente con un asesor humano de Quru.
        Quru no se responsabiliza por interpretaciones, errores u omisiones
        derivados del uso del asistente.
      </p>

      <h2>7. Enlaces a sitios de terceros</h2>
      <p>
        El Sitio puede contener enlaces a sitios web operados por terceros (bancos,
        institutos de vivienda, plataformas de mapas, redes sociales, plataformas
        de video, entre otros). Quru no es responsable del contenido, políticas de
        privacidad ni prácticas de dichos sitios, por lo que se recomienda al
        Usuario revisar los términos y condiciones aplicables al acceder a ellos.
      </p>

      <h2>8. Tratamiento de datos personales</h2>
      <p>
        El tratamiento de los datos personales que el Usuario proporcione a través
        del Sitio se rige por el <strong>Aviso de Privacidad Integral</strong>,
        el cual forma parte integrante de los presentes Términos.
      </p>

      <h2>9. Cookies y tecnologías similares</h2>
      <p>
        El Sitio utiliza cookies y tecnologías similares con la finalidad de mejorar
        la experiencia del Usuario, medir el desempeño del Sitio y, en su caso,
        mostrar publicidad relevante. El detalle del uso de cookies se encuentra
        descrito en el <strong>Aviso de Privacidad Integral</strong>. Al continuar
        navegando en el Sitio, el Usuario acepta el uso de cookies conforme a
        dicha política, salvo manifestación expresa en contrario.
      </p>

      <h2>10. Limitación de responsabilidad</h2>
      <p>
        Quru hace su mejor esfuerzo por mantener actualizada y precisa toda la
        información publicada en el Sitio; sin embargo, no garantiza la ausencia
        absoluta de errores, omisiones, interrupciones, virus informáticos o
        cualquier otro elemento que pueda afectar el correcto funcionamiento del
        Sitio o causar daños al Usuario. En la máxima medida permitida por la
        legislación aplicable, Quru no será responsable por daños directos,
        indirectos, incidentales, especiales o consecuentes derivados del acceso,
        uso o imposibilidad de uso del Sitio o de la información en él contenida.
      </p>

      <h2>11. Disponibilidad del Sitio</h2>
      <p>
        Quru se reserva el derecho de suspender, modificar, interrumpir o
        descontinuar, total o parcialmente, el Sitio o cualquiera de sus
        funcionalidades en cualquier momento y sin previo aviso, por causas
        técnicas, de mantenimiento, comerciales o de cualquier otra naturaleza,
        sin que ello genere responsabilidad alguna en favor del Usuario.
      </p>

      <h2>12. Modificación de los Términos</h2>
      <p>
        Quru podrá modificar los presentes Términos en cualquier momento. Las
        modificaciones surtirán efecto desde su publicación en el Sitio. La fecha
        de última actualización aparece al inicio del documento. El uso continuado
        del Sitio después de cualquier modificación constituye la aceptación tácita
        de los nuevos Términos.
      </p>

      <h2>13. Legislación aplicable y jurisdicción</h2>
      <p>
        Los presentes Términos se rigen por las leyes vigentes de los Estados
        Unidos Mexicanos. Para la interpretación, cumplimiento y ejecución de los
        mismos, las partes se someten expresamente a la jurisdicción de los
        tribunales competentes de la ciudad de Pachuca de Soto, estado de Hidalgo,
        renunciando a cualquier otra jurisdicción que pudiera corresponderles por
        razón de sus domicilios presentes o futuros.
      </p>

      <h2>14. Contacto</h2>
      <p>
        Para cualquier duda, comentario o aclaración relacionada con los presentes
        Términos, el Usuario puede comunicarse a:
      </p>
      <ul>
        <li><strong>Correo electrónico:</strong> <a href="mailto:contacto@quru.mx">contacto@quru.mx</a></li>
        <li><strong>Teléfono:</strong> <a href="tel:+525567911796">+52 55 6791 1796</a></li>
        <li><strong>Domicilio:</strong> Pachuca de Soto, Hidalgo, C.P. 42000, México.</li>
      </ul>
    </>
  );
}
